import { FC } from 'react';

const BUBBLE_FILL = '#FFFFFF';
const BUBBLE_BORDER = '#F1F0EE'; // tw-border-neutral-100
const BUBBLE_BORDER_WIDTH = 4;

// Kept clear of the bubble's 24px corner radius so the tail hangs off a straight stretch of border.
const OFFSET_FROM_RIGHT = 32;

// Horizontal distance between the bubble's right edge and the tip of the tail. Whatever the bubble
// points at has to be lined up with this.
export const TAIL_TIP_FROM_RIGHT = OFFSET_FROM_RIGHT + 2;

/**
 * Triangular tail for the achievement tooltip: it hangs off the bottom-right of the bubble with a
 * vertical right edge and the tip pointing down at the Skill Challenge button.
 */
const PracticeProblemsAchievementTooltipTail: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="36"
    viewBox="0 0 44 36"
    fill="none"
    // `top: 100%` is the inner edge of the bubble's bottom border, so the tail overlaps it.
    style={{ position: 'absolute', top: '100%', right: `${OFFSET_FROM_RIGHT}px`, zIndex: 6 }}
  >
    <path
      d="M2 2H42V34L2 2Z"
      fill={BUBBLE_FILL}
      stroke={BUBBLE_BORDER}
      strokeWidth={BUBBLE_BORDER_WIDTH}
      strokeLinejoin="round"
    />
    {/* Paints over the bubble's bottom border along the top of the triangle, so both read as one
        continuous shape instead of two stacked outlines. */}
    <rect x="4" y="0" width="36" height="6" fill={BUBBLE_FILL} />
  </svg>
);

export default PracticeProblemsAchievementTooltipTail;
